import { IAppState } from '../../common/state';
import { isNewbuildingLayoutListingExperimentActive } from '../../utils/experiments/isNewbuildingLayoutListingExperimentActive';

export const isResidentialComplexLayoutActive = (state: IAppState) => {
  const { abUseExperiments } = state;

  return Boolean(isNewbuildingLayoutListingExperimentActive(abUseExperiments));
};
